import { IFeedConfiguration } from 'feed';
import React, { useState } from 'react';
import ParamCss from '~/components/generic/StepSelectorAndDesign/Sidebar/FeedEditorAppearance/ParamCss';
import HandCardTitleParams from '~/components/generic/StepSelectorAndDesign/Sidebar/FeedEditorAppearance/Tools/CardTitle/HandCardTitleParams';
import { currentCardTitleCssParam } from '~/components/generic/StepSelectorAndDesign/Sidebar/FeedEditorAppearance/Tools/CardTitle/currentCardTitleCssParam';
import { cssSwitchButtons } from '~/components/generic/StepSelectorAndDesign/Sidebar/FeedEditorAppearance/constants';
import Checkbox from '~/components/ui/CheckBox';
import FormItem from '~/components/ui/FormItem';
import SwitchButton from '~/components/ui/SwitchButton';

interface ICardTitleProps {
  configuration: IFeedConfiguration;
  onChange: (
    configuration: IFeedConfiguration,
    isDesignUpdate?: boolean
  ) => void;
}

export const CardTitle: React.FC<ICardTitleProps> = ({ configuration, onChange }) => {
  const [switchButtonState, setSwitchButtonState] = useState<string>(
    configuration.css?.cardTitle ? 'CSS' : 'HAND'
  );
  const onChangeCssParam = (value: string) => {
    const css = configuration.css ?? {};
    css.cardTitle = value;
    onChange({ ...configuration, css }, true);
  };
  
  return (
    <>
      <section className="feed-editor-appearance__section">
        <FormItem
          title="Отображение"
          overlayClassName="feed-editor-appearance__tooltip"
          noHTMLLabel
        >
          <Checkbox
            label="Показать наименование товара"
            className="feed-editor-appearance__checkbox"
            checked={configuration.hasCardTitle}
            onCheck={checked =>
              onChange({ ...configuration, hasCardTitle: checked }, true)
            }
          />
        </FormItem>
      </section>
      {configuration.hasCardTitle && (
        <>
          <section className="feed-editor-appearance__section">
            <FormItem
              title="Как настраивать стили"
              overlayClassName="feed-editor-appearance__tooltip"
              className="feed-editor-appearance__font"
            >
              <SwitchButton
                buttons={cssSwitchButtons}
                activeKey={switchButtonState}
                onClick={setSwitchButtonState}
              />
            </FormItem>
            {switchButtonState === 'CSS' && (
              <ParamCss
                onChangeCssParam={onChangeCssParam}
                value={
                  configuration.css?.cardTitle ??
                  currentCardTitleCssParam(configuration)
                }
              />
            )}
          </section>
          {switchButtonState === 'HAND' && (
            <HandCardTitleParams
              isActive={switchButtonState === 'HAND'}
              configuration={configuration}
              onChange={onChange}
              onChangeCssParam={onChangeCssParam}
            />
          )}
        </>
      )}
    </>
  );
};
